import * as yup from 'yup';
import moment from 'moment';
import { FORM_ERROR_MESSAGES } from '../../../internalConstants';

const minDate = '1900-01-01';
const today = moment();

export const dampReportValidationSchema = yup.object().shape({
  permissionType: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  dateOfTest: yup.string()
    .test('date-value-test', (value, context) => {
      const dateValue = moment(value, 'YYYY-MM-DD', true);
      const path = context.path;
      if (!value) {
        return context.createError({ path, message: FORM_ERROR_MESSAGES.REQUIRED_FIELD });
      }
      if (moment(value).isBefore(minDate, 'year') || moment(value).isAfter(today)) {
        return context.createError({ path, message: FORM_ERROR_MESSAGES.INVALID_ENTRY });
      }
      return dateValue.isValid() || context.createError({ path, message: FORM_ERROR_MESSAGES.INVALID_ENTRY });
    }).required(FORM_ERROR_MESSAGES.REQUIRED_FIELD),
  reasonForTest: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  ageRange: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  ssaaType: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  state: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  region: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  positiveTo: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  methodOfTesting: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  declaration: yup.string()
    .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION),
  alcoholReading: yup.string()
    .when('positiveTo', {
      is: 'ALCOHOL',
      then: yup.string()
        .required(FORM_ERROR_MESSAGES.REQUIRED_OPTION)
    }),
});
